import { DEFAULT_COLOR_PRIMARY, DEFAULT_LINK, DEFAULT_TEXT } from './constants'

export interface ButtonInterface {
  type: 'button' | 'link'
  look: 'solid' | 'border'
  color: string
  textColor?: string
  url: string
  text: string
}

export const getButtonStyle = (button: ButtonInterface) => {
  if (button.look === 'border') {
    return {
      border: `2px solid ${button.color}`,
      color: button.color,
    }
  } else {
    return {
      'background-color': button.color,
      color: button.textColor || 'white',
    }
  }
}

export const buttonsSchemaProperties = {
  buttons: {
    type: 'array',
    title: 'A list of buttons',
    'ui:options': {
      showIndexNumber: true,
    },
    items: {
      type: 'object',
      required: ['buttonUrl', 'buttonText'],
      properties: {
        type: {
          title: 'Button type',
          enum: ['button', 'link'],
          enumNames: ['Button', 'Link'],
          default: 'button',
          'ui:widget': 'RadioWidget',
        },
        look: {
          title: 'Button look',
          enum: ['solid', 'border'],
          enumNames: ['Solid', 'Border'],
          default: 'solid',
          'ui:widget': 'RadioWidget',
          'ui:hidden': '{{parentFormData.type === "link"}}',
        },
        color: {
          title: 'Color',
          type: 'string',
          default: DEFAULT_COLOR_PRIMARY,
        },
        textColor: {
          title: 'Text color',
          type: 'string',
          default: '#ffffff',
          'ui:hidden': '{{parentFormData.look !== "solid"}}',
        },
        url: {
          title: 'Button url',
          type: 'string',
          default: DEFAULT_LINK,
        },
        text: {
          title: 'Button text',
          type: 'string',
          default: DEFAULT_TEXT,
        },
      },
    },
  },
}

export const textAlignSchemaField = {
  title: 'Text align',
  type: 'string',
  enum: ['start', 'center', 'end'],
  enumNames: ['Left', 'Center', 'Right'],
  default: 'start',
}

export const titleSchemaProperties = {
  title: {
    title: 'Title',
    type: 'string',
    default: '',
  },
  titleAlign: {
    ...textAlignSchemaField,
    title: 'Title align',
  },
}

export const titleSizeMap = {
  xl: 'text-xl',
  xl2: 'text-2xl',
  xl3: 'text-2xl md:text-3xl',
} as { [key: string]: string }

export const titleSizeSchemaProperties = {
  titleSize: {
    title: 'Title size',
    type: 'string',
    enum: ['xl', 'xl2', 'xl3'],
    enumNames: ['XL', '2XL', '3XL'],
    default: 'xl3',
  },
}

export const blockShadowSchemaProperties = {
  blockShadow: {
    title: 'Display block shadow',
    type: 'boolean',
    default: false,
  },
}
